export default __webpack_public_path__ + "a019f43ba2085ad6db39d32ce2985e1e.png";